import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { initStateMemberData } from "mocks/memberData";
import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { base64ToBlob } from "utils/HelperFunction";
import { allowedFields, jsonKeys, loadDocDataFromSoProcess, mappingReceipt, mapProductToRequestItem, mapProductToRequestUpdateItem } from "utils/HelperReceiptFunction";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { getHQAddressByDate } from "../../redux/handlers/logic/getHQAddressByDate.handler";
import { nanoid } from "@reduxjs/toolkit";
import { getNewReceiptById } from "../../redux/slices/logic/getNewReceiptById.slice";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
import { isShowBranch, mappingSearchMember } from "utils/HelperMemberFunction";
import { clearUpdateNewReceipt, updateNewReceipt } from "../../redux/slices/logic/updateNewReceipt.slice";
import { clearCreateNewReceipt, createNewReceipt } from "../../redux/slices/logic/createNewReceipt.slice";
import { initStateDoData } from "mocks/doData";
import { getNewInvoiceById } from "../../redux/slices/logic/getNewInvoiceById.slice";
import moment from "moment";
import { initStateReceiptData } from "mocks/receiptData";
export default function useReceiptForm(param) {
    var receiptID = param.receiptID, invoiceID = param.invoiceID, setTab = param.setTab, setProductRow = param.setProductRow, columnsort = param.columnsort, setColumnsort = param.setColumnsort, attachments = param.attachments, setAttachments = param.setAttachments, setAttachmentDeliver = param.setAttachmentDeliver, setTagSelected = param.setTagSelected, setUpdateDocIds = param.setUpdateDocIds, modalReceiptModalState = param.modalReceiptModalState;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalDocModalContext = useGlobalDocModalContext(), modalNotiDocAlert = _useGlobalDocModalContext.modalNotiDocAlert, setModalNotiDocAlert = _useGlobalDocModalContext.setModalNotiDocAlert;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var modalNotApprove = modalReceiptModalState.modalNotApprove, setModalSuccess = modalReceiptModalState.setModalSuccess, setModalNotApprove = modalReceiptModalState.setModalNotApprove, setModalConfirmCancel = modalReceiptModalState.setModalConfirmCancel;
    var schema = yup.object().shape({
        doc_issue_date: yup.string().required(),
        doc_due_date: yup.string().required("ต้องระบุวันที่ครบกำหนด").test("doc_due_date_after_issue", "วันที่ครบกำหนดต้องไม่น้อยกว่าวันที่ออกเอกสาร", function(value) {
            var doc_issue_date = this.parent.doc_issue_date;
            if (!value || !doc_issue_date) return true; // ปล่อยให้ required เช็คเอง
            return moment(value).isSameOrAfter(moment(doc_issue_date), "day");
        }),
        dim_mst_price_category_id: yup.string().required(),
        fact_member_id: yup.string().required(),
        dim_mst_payment_type_id: yup.string().required(),
        dim_branch_id: yup.string().required(),
        member_address: yup.string().required("กรุณาเพิ่มที่อยู่ก่อน"),
        not_approve_reason: yup.string().when([], {
            is: function() {
                return modalNotApprove.open;
            },
            then: function(schema) {
                return schema.required();
            }
        })
    });
    // Reducers
    var reducers = {
        createNewReceipt: useAppSelector(function(state) {
            return state.createNewReceiptReducer;
        }),
        updateNewReceipt: useAppSelector(function(state) {
            return state.updateNewReceiptReducer;
        }),
        getNewReceiptById: useAppSelector(function(state) {
            return state.getNewReceiptByIdReducer;
        }),
        getNewInvoiceById: useAppSelector(function(state) {
            return state.getNewInvoiceByIdReducer;
        })
    };
    var isFormReceiptLoading = useMemo(function() {
        return reducers.createNewReceipt.isFetching || reducers.updateNewReceipt.isFetching || reducers.getNewReceiptById.isFetching || reducers.getNewInvoiceById.isFetching;
    }, [
        reducers.createNewReceipt.isFetching,
        reducers.updateNewReceipt.isFetching,
        reducers.getNewReceiptById.isFetching,
        reducers.getNewInvoiceById.isFetching
    ]);
    var _useState = _sliced_to_array(useState(false), 2), formdisabled = _useState[0], setFormdisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState(initStateReceiptData), 2), formdata = _useState1[0], setFormdata = _useState1[1];
    var _useState2 = _sliced_to_array(useState(initStateMemberData), 2), pdata = _useState2[0], setPdata = _useState2[1];
    var _useState3 = _sliced_to_array(useState("สร้างใบเสร็จ"), 2), headerName = _useState3[0], setheaderName = _useState3[1];
    var formatResult = function(item) {
        var mappingMember = mappingSearchMember(item);
        var isShowBranchMember = isShowBranch({
            custType: item.member_customer_type,
            isHQ: item.member_is_hq,
            branchNo: item.member_branch_no
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        mappingMember.customerName,
                        isShowBranchMember ? " - (".concat(mappingMember.branchCode, ")") : ""
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "tc-5",
                    children: [
                        mappingMember.customerID ? mappingMember.customerID : "ไม่พบเลขผู้เสียภาษี",
                        " ",
                        "- ",
                        mappingMember.customerCode
                    ]
                })
            ]
        }, nanoid());
    };
    var getHQAddress = function(payload) {
        dispatch(getHQAddressByDate(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getData = function() {
        var id = receiptID;
        dispatch(getNewReceiptById({
            id: id,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var getInvoiceData = function() {
        var id = invoiceID;
        dispatch(getNewInvoiceById({
            id: id,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleMainSubmit = function(param) {
        var values = param.values, resetForm = param.resetForm;
        // console.log('values', values);
        var formdataPayload = new FormData();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                var value = values[key];
                if (value === undefined || value === null) return "continue";
                if (key === "doc_files" && Array.isArray(value)) {
                    value.forEach(function(file, index) {
                        if (file.docData) {
                            var blob = base64ToBlob(file.docData);
                            formdataPayload.append(key, blob, "".concat(file.docName));
                        }
                    });
                } else if (jsonKeys.includes(key)) {
                    formdataPayload.append(key, JSON.stringify(value));
                } else if (Array.isArray(value)) {
                    value.forEach(function(item) {
                        formdataPayload.append(key, item);
                    });
                } else {
                    formdataPayload.append(key, value);
                }
            };
            for(var _iterator = allowedFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // console.log(formdataPayload);
        var id = receiptID;
        var payload = formdataPayload;
        if (!receiptID) {
            dispatch(createNewReceipt({
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            dispatch(updateNewReceipt({
                id: id,
                payload: payload,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var handlePreSubmit = function(param) {
        var productRow = param.productRow, setFieldValue = param.setFieldValue, handleSubmit = param.handleSubmit, values = param.values, attachments = param.attachments, attachmentDeliver = param.attachmentDeliver, tagselected = param.tagselected, updateDocIds = param.updateDocIds, setModalAlert = param.setModalAlert, setErrors = param.setErrors;
        var product = productRow.filter(function(prev) {
            return prev.productCode !== "";
        });
        if (product && product.length > 0) {
            var newItems = mapProductToRequestItem(product);
            schema.validate(_object_spread_props(_object_spread({}, values), {
                fact_new_receipt_items: newItems,
                attachments: attachments,
                tagselected: tagselected
            }), {
                abortEarly: false
            }).then(function() {
                setFieldValue("doc_files", _to_consumable_array(attachments.map(function(v) {
                    return {
                        docData: v.docFileData,
                        docName: v.docFile
                    };
                })).concat(_to_consumable_array(attachmentDeliver.map(function(v) {
                    return {
                        docData: v.docFileData,
                        docName: v.docFile
                    };
                }))));
                var itemField = "fact_new_receipt_items";
                setFieldValue(itemField, newItems);
                setFieldValue("tag_receipts", tagselected);
                if (receiptID) {
                    setFieldValue("update_doc_ids", updateDocIds);
                }
                handleSubmit();
            }).catch(function(err) {
                var _err_errors;
                var errorMessage = ((_err_errors = err.errors) === null || _err_errors === void 0 ? void 0 : _err_errors.join("\n")) || "Invalid data. Please check the form.";
                console.log(errorMessage);
                var formErrors = {};
                err.inner.forEach(function(e) {
                    if (e.path) formErrors[e.path] = e.message;
                });
                setErrors(formErrors);
            });
        } else {
            setModalAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
        }
    };
    useEffect(function() {
        if (reducers.createNewReceipt.data && !reducers.createNewReceipt.isError) {
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            // setFormdisabled(true);
            dispatch(clearCreateNewReceipt());
            var createdData = reducers.createNewReceipt.data.data;
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                setModalNotiDocAlert(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        open: prev.extra.genDocNumber !== createdData.doc_number,
                        extra: {
                            genDocNumber: prev.extra.genDocNumber,
                            createdDocNumber: createdData.doc_number
                        }
                    });
                });
                navigate("/sale/invoice/edit/".concat(id));
            } else {
                navigate("/sale/delivery-order");
            }
        }
        if (reducers.updateNewReceipt.data && !reducers.updateNewReceipt.isError) {
            setModalNotApprove(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalConfirmCancel(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            setTab(1);
            dispatch(clearUpdateNewReceipt());
            getData();
        }
        if (reducers.getNewReceiptById.data && !reducers.getNewReceiptById.isError && receiptID) {
            var soData = reducers.getNewReceiptById.data.data;
            if (!soData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = mappingReceipt({
                soData: soData,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setAttachments: setAttachments,
                setAttachmentDeliver: setAttachmentDeliver,
                setTagSelected: setTagSelected
            });
            var endDate = dataWithReplacements.doc_issue_date;
            getHQAddress({
                end_date: endDate
            });
            setFormdata(dataWithReplacements);
        }
        if (reducers.getNewInvoiceById.data && !reducers.getNewInvoiceById.isError && invoiceID) {
            var soData1 = reducers.getNewInvoiceById.data.data;
            if (!soData1) {
                return navigate("/404", {
                    replace: true
                });
            }
            var docSelected = soData1;
            loadDocDataFromSoProcess({
                docSelected: docSelected,
                setProductRow: setProductRow,
                setFormdata: setFormdata,
                setPdata: setPdata
            });
        }
    }, [
        reducers.createNewReceipt.data,
        reducers.updateNewReceipt.data,
        reducers.getNewReceiptById.data,
        reducers.getNewInvoiceById.data
    ]);
    useEffect(function() {
        if (invoiceID) {
            getInvoiceData();
        }
        if (receiptID) {
            getData();
            setheaderName("แก้ไขใบเสร็จ");
        } else {
            setFormdata(initStateDoData);
        }
    }, [
        receiptID,
        invoiceID
    ]);
    useEffect(function() {
        if (receiptID && (formdata === null || formdata === void 0 ? void 0 : formdata.factDocFileReceipt)) {
            var deleteCandidateDocIds = formdata.factDocFileReceipt.map(function(item) {
                return item.id;
            });
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !attachments.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            setUpdateDocIds(deleteDocIds);
        }
    }, [
        formdata,
        attachments
    ]);
    // useEffect(() => {
    //   setIsLoading(isFormReceiptLoading);
    // }, [isFormReceiptLoading]);
    return {
        schema: schema,
        formdisabled: formdisabled,
        setFormdisabled: setFormdisabled,
        formdata: formdata,
        setFormdata: setFormdata,
        pdata: pdata,
        setPdata: setPdata,
        formatResult: formatResult,
        handleMainSubmit: handleMainSubmit,
        handlePreSubmit: handlePreSubmit,
        headerName: headerName,
        isFormReceiptLoading: isFormReceiptLoading
    };
}
